import React from 'react';
import { Search } from 'lucide-react';
import SelectInput from '../InputComponent/SelectInput';

const PaymentToolbar = ({ filters, onFilterChange, isShowFilter = true, plans }) => {
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        onFilterChange(prev => ({ ...prev, [name]: value }));
    };

    return (
        <div className="flex flex-col md:flex-row gap-4 items-end">
            <div className="relative w-full md:flex-1">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                <input
                    type="text"
                    name="search"
                    placeholder="Search Member ID,Member Name..."
                    value={filters.search}
                    onChange={handleInputChange}
                    className="w-full pl-12 pr-4 py-2.5 border bg-white border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-red/50 focus:border-brand-red outline-none transition-all"
                />
            </div>
            {isShowFilter &&
                <div className="flex gap-4 w-full md:w-auto">
                    <SelectInput label={"Plans"} name="plan" value={filters.plan} onChange={handleInputChange} >
                        <option value="All">All</option>
                        {plans.filter(p => p.status === 'active').map(p => (
                            <option key={p.id} value={p.id}>{p.name}</option>
                        ))}
                    </SelectInput> 
                    <SelectInput label={"Payment Method"} name="paymentMethod" value={filters.paymentMethod} onChange={handleInputChange} >
                        <option value="All">All</option>
                        <option value={'cash'}>Cash</option>
                        <option value={'card'}>Card</option>
                        <option value={'online'}>Online</option>
                    </SelectInput> 
                </div>}
        </div>
    );
};

export default PaymentToolbar;
